"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJEnemy = exports.CGJEnemyType = exports.CGJEnemyBehavior = void 0;
const CGJEntity_1 = require("./CGJEntity");
var CGJEnemyBehavior;
(function (CGJEnemyBehavior) {
    CGJEnemyBehavior[CGJEnemyBehavior["RandomDir"] = 0] = "RandomDir";
    CGJEnemyBehavior[CGJEnemyBehavior["RandomPoint"] = 1] = "RandomPoint";
    CGJEnemyBehavior[CGJEnemyBehavior["Follow"] = 2] = "Follow";
})(CGJEnemyBehavior = exports.CGJEnemyBehavior || (exports.CGJEnemyBehavior = {}));
;
var CGJEnemyType;
(function (CGJEnemyType) {
    CGJEnemyType[CGJEnemyType["Slime"] = 0] = "Slime";
    CGJEnemyType[CGJEnemyType["SlimeLarge"] = 1] = "SlimeLarge";
    CGJEnemyType[CGJEnemyType["Skeleton"] = 2] = "Skeleton";
    CGJEnemyType[CGJEnemyType["SkeletonLarge"] = 3] = "SkeletonLarge";
})(CGJEnemyType = exports.CGJEnemyType || (exports.CGJEnemyType = {}));
;
class CGJEnemy extends CGJEntity_1.CGJEntity {
    constructor(scene, type, spriteName, behavior, hitbox, tintColor, pos, size, angle, targetSpeed) {
        super(scene, spriteName, pos, size, hitbox);
        if (tintColor)
            this.setTint(tintColor);
        //Phaser.Display.Color.RandomRGB(0, 256).color32
        this.enemyType = type;
        this.behavior = behavior;
        this.setBounce(1);
        this.setVelocity(targetSpeed * Math.sin(angle), targetSpeed * Math.cos(angle));
        this.targetSpeed = targetSpeed;
        this.speedModifier = 1;
        this.changeDirection();
    }
    update(now, delta) {
        if (!this.dead) {
            let currSpeed = this.body.speed;
            let x = this.body.velocity.x;
            let y = this.body.velocity.y;
            let newSpeed = currSpeed;
            const target = this.targetSpeed * this.speedModifier;
            if (currSpeed > target) {
                newSpeed = Math.min(currSpeed * 0.9 * (delta / 16), target);
            }
            else if (currSpeed < target) {
                newSpeed = Math.min(currSpeed * 1.1 * (delta / 16), target);
            }
            let stopped = newSpeed == 0;
            if (stopped) {
                newSpeed = target * .5;
            }
            if (this.behavior == CGJEnemyBehavior.RandomDir) {
                let angle = stopped ? Math.random() * Math.PI * 2 : Math.atan2(y, x);
                this.scene.physics.velocityFromRotation(angle, newSpeed, this.body.velocity);
            }
            else if (this.behavior == CGJEnemyBehavior.Follow) {
                this.scene.physics.moveToObject(this, this.scene.player, newSpeed);
            }
            this.anims.timeScale = newSpeed / 400;
        }
        super.update(now, delta);
    }
}
exports.CGJEnemy = CGJEnemy;
